module.exports = __webpack_public_path__ + "img/icon_2_24.6c6bb36f.png";